









































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Discount, ApiError } from '@/api';
import { snackModule, authModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import DatePicker from '@/components/DatePicker.vue';

@Component({
  components: {
    ConfirmDialog,
    DatePicker,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  discount: Discount | null = null;

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredRate = [
    (v: string) =>
      v8n()
        .number()
        .between(0, 100)
        .test(Number(v)) || 'Must be a number between 0 and 100',
  ];

  get discountId() {
    return this.$route.params.discountId;
  }

  get discountRate() {
    if (!this.discount) {
      return '0';
    }
    return String(parseFloat(this.discount.rate) * 100);
  }
  set discountRate(val) {
    if (!this.discount) {
      return;
    }
    const rateVal = parseFloat(val);
    if (rateVal > 0) {
      this.discount.rate = String(rateVal / 100);
    } else {
      this.discount.rate = '0';
    }
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.discount && this.discount.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.discount) {
      return;
    }

    this.discount.promoCode = this.discount.promoCode.toUpperCase();

    try {
      await this.discount.save();
      if (
        this.$route.name === 'admin-discounts-add' &&
        this.discount &&
        this.discount.id
      ) {
        this.$router.push({
          name: 'admin-discounts-edit',
          params: { discountId: this.discount.id },
        });
        snackModule.showSnackbar('Discount Created');
      } else {
        snackModule.showSnackbar('Discount Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-discounts-edit' && this.discountId) {
      try {
        this.discount = (await Discount.find(this.discountId)).data;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Discount not found');
      }
    } else {
      this.discount = new Discount();
    }
  }
}
